import { render } from "./ApprovedLiquidations.vue?vue&type=template&id=6f3dc7a4"
import script from "./ApprovedLiquidations.vue?vue&type=script&lang=js"
export * from "./ApprovedLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__